const BASE_API_URL = process.env.VUE_APP_API_BASE_URL;

import axios from 'axios';

function apiRequest(options, showLoading = true, handleValidationErrors = false) {
  if (showLoading) {
    loading(true);
  }
  return new Promise((resolve, reject) => {
    axios(options)
      .then(response => {
        if (response.status === 204) {
          resolve({});
        } else {
          resolve(response.data);
        }
        loading(false);
      })
      .catch(error => {
        loading(false);
        if (handleValidationErrors && error.response && error.response.status === 400) {
          reject(error.response.data);
        } else {
          dispatchApiErrorEvent(error);
        }
      });
  });
}

function dispatchApiErrorEvent(error) {
  let event = new CustomEvent('apiError');
  let errorMessage;
  if (error.response && error.response.data && error.response.data.message) {
    errorMessage = error.response.data.message;
  } else if (error.message) {
    errorMessage = error.message;
  } else {
    errorMessage = 'Unknown error';
  }
  event.message = {
    title: error.error || 'Error',
    body: errorMessage
  };
  document.dispatchEvent(event);
}

/* For loading animation */
function loading(value) {
  let event = new CustomEvent('loading');
  event.value = value;
  document.dispatchEvent(event);
}

export default {
  register(data) {
    let url = BASE_API_URL + 'register';
    return apiRequest({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data
    }, true, true);
  },
  resetPassword(username) {
    let url = BASE_API_URL + 'resetPassword';
    return apiRequest({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        username: username
      }
    }, true, true);
  },
  verifyCode(code) {
    let url = BASE_API_URL + 'confirm';
    return apiRequest({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        code
      }
    }, true, true);
  },
  login(username, password) {
    let url = BASE_API_URL + 'login';
    return apiRequest({
      method: 'POST',
      url: url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        username,
        password
      }
    }, true, true);
  },
  changePassword(newPassword, newPasswordConfirm) {
    let url = BASE_API_URL + 'password';
    return apiRequest({
      method: 'POST',
      url: url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        newPassword,
        newPasswordConfirm
      }
    }, true, true);
  },
  sendResetPasswordCode(uid) {
    let url = BASE_API_URL + 'reset/send';
    return apiRequest({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        uid
      }
    }, true, true);
  },
  initResetPassword(code) {
    let url = BASE_API_URL + 'reset/init';
    return apiRequest({
      method: 'POST',
      url: url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        code
      }
    }, true, true);
  },
  recoverUsername(email) {
    let url = BASE_API_URL + 'username';
    return apiRequest({
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: {
        email
      }
    }, true, true);
  },
  logout() {
    let url = BASE_API_URL + 'logout';
    return apiRequest({
      method: 'POST',
      url: url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, true, true);
  }
};
